import * as React from "react";
import "./bubbles.js";
import "./getBig.js";
import "./highfive.css";

class BubbleAnimation extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div itemID="high">
        <script type="text/javascript" src="bubbles.js"></script>
        <script type="text/javascript" src="getBig.js"></script>
      </div>
    );
  }
}

export default BubbleAnimation;



// WEBPACK FOOTER //
// ./src/components/HighFive/bubblejs.tsx